import { soundchartsApi } from "./axios";

export const soundchartsEndpoints = {
  // Get song playlists with type filtering
  getSongPlaylistsByType: (
    uuid: string,
    platform: string,
    type: 'editorial' | 'algorithmic' | 'algotorial' | 'curators_listeners' | 'all',
    params: {
      offset?: number;
      limit?: number;
      sortBy?: string;
      sortOrder?: string;
      currentOnly?:number;
      countryCode?: string
       }
  ) =>
    soundchartsApi.get(`/v2/song/${uuid}/playlist/current/${platform}`, {
      params: {
        type: type,
        offset: params.offset || 0,
        limit: params.limit || 100,
        sortBy: params.sortBy || "entryDate",
        sortOrder: params.sortOrder || "desc",
        currentOnly:params.currentOnly,
        countryCode: params.countryCode || undefined
      },
    }),

  // Apple Music editorial playlist entries require API v2.20 (v2 omits real placements like
  // "Today's Hits" - confirmed with SoundCharts, see
  // Outputs/Cadence/SoundCharts_API_Followup_2026-07-02.md). No other DSP/type needs this.
  // sortBy=position (a documented SoundCharts sort option) surfaces high-relevance placements
  // before country-level duplicates of the same playlist within a fetched page. Note: ties at
  // the same position (many countries can tie) aren't broken further server-side, so a
  // distinct real placement could still land on a later page than a tied duplicate.
  getAppleMusicEditorialPlaylists: (
    uuid: string,
    params: {
      offset?: number;
      limit?: number;
      sortBy?: string;
      sortOrder?: string;
      currentOnly?: number;
      countryCode?: string;
    }
  ) =>
    soundchartsApi.get(`/v2.20/song/${uuid}/playlist/current/apple-music`, {
      params: {
        type: "editorial",
        offset: params.offset || 0,
        limit: params.limit || 100,
        sortBy: params.sortBy || "position",
        sortOrder: params.sortOrder || "asc",
        currentOnly: params.currentOnly,
        countryCode: params.countryCode || undefined,
      },
    }),

  // Get song by ISRC
  getSongByISRC: (isrc: string) => soundchartsApi.get(`/v2/song/by-isrc/${isrc}`),
  getAudienceByUUIDAndPlatform: (uuid: string, platform: string,startDate:string,endDate:string) =>
    soundchartsApi.get(`/v2/song/${uuid}/audience/${platform}` ,{
      params: {
        startDate: startDate,
        endDate: endDate
    }}),
    //popularity by artist
    getPopularityByArtist: (uuid: string, platform: string, query='') =>
    soundchartsApi.get(`/v2/artist/${uuid}/popularity/${platform}?${query}`),
     //popularity by song
    getPopularityBySong: (uuid: string, platform: string, query='') =>
    soundchartsApi.get(`/v2/song/${uuid}/popularity/${platform}?${query}`),
    //Get an artist's fan retention rate across platforms.
    getFanRetentionByArtist: (uuid: string, platform: string, query='') =>
    soundchartsApi.get(`/v2/artist/${uuid}/${platform}/retention?${query}`,),
    // Get audience report - latest
    getAudienceReportLatest: (uuid: string, platform: string) =>
    soundchartsApi.get(`/v2/artist/${uuid}/audience/${platform}/report/latest`),
    //get audience report
    getAudience : (uuid: string, platform: string, query='') =>
    soundchartsApi.get(`/v2/artist/${uuid}/audience/${platform}?${query}`),
    //get radio spins
    getRadioSpins : (uuid: string, query='')=>
    soundchartsApi.get(`/v2/song/${uuid}/broadcasts?${query}`),
    // Get artist details by platform identifier (e.g. spotify, apple-music)
    getArtistByPlatform: (platform: string, identifier: string) =>
      soundchartsApi.get(`/v2/artist/by-platform/${platform}/${identifier}`),
    // Get artist playlists (current/past) by platform
    getArtistPlaylistsByType: (
      uuid: string,
      platform: string,
      params: {
        offset?: number;
        limit?: number;
        currentOnly?: number;
        type?: 'editorial' | 'algorithmic' | 'algotorial';
        countryCode?: string;
      } = {}
    ) =>
      soundchartsApi.get(`/v2.20/artist/${uuid}/playlist/current/${platform}`, {
        params: {
          currentOnly: params.currentOnly,
          type: params.type ?? 'editorial',
          sortBy: "entryDate",
          sortOrder: "desc",
          offset: params.offset ?? 0,
          limit: params.limit ?? 100,
          countryCode: params.countryCode || undefined,
        },
      }),
    getArtistByUUID: (uuid: string) => soundchartsApi.get(`/v2/artist/${uuid}`),
};